import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UserService } from '../../../../services/core.user.service';
import { ChangeEmailHelper } from './changeemail.helper';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'gf-changeemail-request-modal',
  template: require('./changeemail.request.modal.component.html')
})
export class ChangeEmailRequestModalComponent implements OnInit {
  @Output() onClose = new EventEmitter<any>();

  form: UntypedFormGroup;
  user: any;
  msg = '';
  sending = false;
  requireCaptcha = false;
  captcha: string;
  captchaRefresh = false;

  constructor(
    private fb: UntypedFormBuilder,
    private userService: UserService,
    private changeEmailHelper: ChangeEmailHelper
  ) {}

  ngOnInit(): void {
    this.user = this.userService.getUser();
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      emailConfirm: ['', [Validators.required, Validators.email]]
    });
  }

  close(result = false, delay = 0): void {
    setTimeout(() => {
      this.onClose.emit();
    }, delay);
  }

  async sendRequest(event: Event): Promise<void> {
    event.preventDefault();
    event.stopPropagation();

    if (this.form.invalid) {
      return;
    }

    this.sending = true;

    try {
      await this.changeEmailHelper.postRequest(
        this.form.get('email').value,
        this.form.get('emailConfirm').value,
        this.user.unixName,
        this.captcha
      );
      this.close(true, 250);
    } catch (err) {
      if (err?.data?.type === 'user-registration-request-exists') {
        this.close(true, 250);
      } else {
        this.msg = err.message || 'An error occurred';
      }
    } finally {
      this.sending = false;
    }
  }
}

